import { render, staticRenderFns } from "./BillingPolicy.vue?vue&type=template&id=4ff1db14&scoped=true"
import script from "./BillingPolicy.vue?vue&type=script&lang=js"
export * from "./BillingPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff1db14",
  null
  
)

export default component.exports